import { useMutation, useQueryClient } from '@tanstack/react-query'
import { appendDescriptionAndGenerate } from '@/api/orgsAPI'
import type { UUID } from 'crypto'

export function useAppendDescriptionAndGenerate() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({
      token,
      orgUuid,
      additionalText,
    }: {
      token: string
      orgUuid: UUID
      additionalText: string
    }) => appendDescriptionAndGenerate(token, orgUuid, additionalText),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['currentOrgs'] })
    },
  })
}
